import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const entity = 'origin_destination'
const actions = crud(
    'origin_destination',
    'el origen-destino',
    'los origenes-destinos'
)

const updateSync = (item) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(`/${entity}/utils/update_sync`, {
            method: 'PATCH',
            body: JSON.stringify(item),
            headers: {
                Authorization: state.app.user.token,
            },
            successMessage: `Se actualizó el origen-destino correctamente.`,
        })

        dispatch({
            type: `UPDATE_SYNC_${entity.toUpperCase()}`,
            response: res.body,
        })

        return res.body
    }
}

const addSync = (item) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(`/${entity}/utils/add_sync`, {
            method: 'POST',
            body: JSON.stringify(item),
            headers: {
                Authorization: state.app.user.token,
            },
            params: {
                will_create_user: item.will_create_user,
            },
            successMessage: `Se agregó el origen-destino correctamente.`,
        })

        console.log('respuesta del api', res)

        dispatch({
            type: `ADD_SYNC_${entity.toUpperCase()}`,
            response: res.body,
        })
        return res.body
    }
}

const excelLayoutOriginsDestinations = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/generate_layout_excel_origins_destinations`,
            {
                method: 'PUT',
                headers: {
                    Authorization: state.app.user.token,
                    'Content-Type': 'application/json'
                },
                // CORRECCIÓN: Enviamos 'options' directo (sin envolverlo en { options })
                body: JSON.stringify(options), 
            }
        )
            .then((res) => {
                let buff = Buffer.from(res.body)
                return buff
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'OrigenesDestinos_Layout.xlsx')
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
            })
    }
}

const excelLayoutContacts = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/generate_layout_excel_contacts`,
            {
                method: 'PUT',
                headers: {
                    Authorization: state.app.user.token,
                    'Content-Type': 'application/json'
                },
                // CORRECCIÓN: Enviamos 'options' directo
                body: JSON.stringify(options),
            }
        )
            .then((res) => {
                let buff = Buffer.from(res.body)
                return buff
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'ContactosOD_Layout.xlsx')
                document.body.appendChild(link)
                link.click()
                link.parentNode.removeChild(link)
            })
    }
}

const importFileOriginsDestinations = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/import_data_from_excel_origins_destinations`,
            {
                method: 'PUT',
                json: false,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: {
                    file: options.files,
                },
            }
        )

        dispatch({
            type: 'IMPORT',
            payload: res.body,
        })

        return res.body
    }
}

const importFileContacts = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/import_data_from_excel_contacts`,
            {
                method: 'PUT',
                json: false,
                headers: {
                    Authorization: state.app.user.token,
                },
                body: {
                    file: options.files,
                },
            }
        )

        dispatch({
            type: 'IMPORT',
            payload: res.body,
        })

        return res.body
    }
}

const verifyImportDataOriginsDestinations = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/validate_data_from_import_origins_destinations`,
            {
                method: 'PUT',
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify(options.data),
            }
        )

        dispatch({
            type: 'IMPORT',
            payload: res.body,
        })

        return res.body
    }
}

const verifyImportDataContacts = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/validate_data_from_import_contacts`,
            {
                method: 'PUT',
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify(options.data),
            }
        )

        dispatch({
            type: 'IMPORT',
            payload: res.body,
        })

        return res.body
    }
}

const importOriginsDestinations = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(
            `/origin_destination/import_origins_destinations`,
            {
                method: 'POST',
                headers: {
                    Authorization: state.app.user.token,
                },
                body: JSON.stringify({
                    options,
                }),
                successMessage: `Se agreron los origenes-destinos correctamente.`,
            }
        )
        showSuccessMessage('Se registraron los origenes-destinos correctamente')
        return res.body
    }
}

const importContacts = (options) => {
    return async (dispatch, getState) => {
        const state = getState()

        const res = await callApi(`/origin_destination/import_contacts`, {
            method: 'POST',
            headers: {
                Authorization: state.app.user.token,
            },
            body: JSON.stringify({
                options,
            }),
            successMessage: `Se agreron los contactos correctamente.`,
        })
        showSuccessMessage('Se registraron los contactos correctamente')
        return res.body
    }
}

export default {
    ...actions,
    updateSync,
    addSync,
    excelLayoutOriginsDestinations,
    excelLayoutContacts,
    importFileOriginsDestinations,
    importFileContacts,
    verifyImportDataOriginsDestinations,
    verifyImportDataContacts,
    importOriginsDestinations,
    importContacts,
}
